// libs
import React, { useEffect } from 'react';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';

// components
import HomePageMobile from 'shared/layouts/Homepage/HomePageMobile';
import HomePageDesktop from 'shared/layouts/Homepage/HomePageDesktop';

// helpers
import { log } from 'shared/helpers/newRelic';
import { TAG_IDENTIFIER } from 'shared/helpers/SentryLogger/constants';

function HomePage() {
  useEffect(() => {
    // Attached TODO

    return () => {
      try {
        //@ts-ignore
        if (window.Verloop !== undefined && window.Verloop.livechat !== undefined) {
          //@ts-ignore
          window.Verloop.livechat.stop();
        }
      } catch (err) {
        log({
          errTitle: 'Error in Verloop - hp',
          error: err,
          tags: { [TAG_IDENTIFIER.MODULE]: 'Verloop' },
        });
      }
    };
  }, []);

  return (
    <>
      <RouteChunkRenderer
        mobileComponent={<HomePageMobile fallback={<ChunkFallback />} />}
        desktopComponent={<HomePageDesktop fallback={<ChunkFallback />} />}
      />
    </>
  );
}

export default HomePage;
